/**
 * Rechten per schoolbeheerder (26-10-2026, migratie 117).
 *
 * Zelfde regel als backend/src/middleware/beheerrechten.js en _beheerrechten_effectief in de
 * database:
 *   - admin (TestWisely): alles;
 *   - schoolbeheerder: zijn eigen rechten (docenten.beheerrechten); de hoofdbeheerder heeft
 *     altijd 'beheerders';
 *   - docent: niets;
 *   - zonder het veld (migratie 117 nog niet gedraaid): een beheerder mag alles, zoals vroeger.
 * De server controleert altijd zelf; dit bepaalt alleen wat het scherm laat zien.
 */

// Vaste volgorde. kort = op een chip; uitleg = korte zinnen in het rechtenvenster.
export const BEHEERRECHTEN = [
  {
    key: 'docenten',
    label: 'Docenten beheren',
    kort: 'Docenten',
    uitleg: 'Docenten uitzetten en weer aanzetten. De lestaak van een beheerder aanpassen. De tweede stap van een docent resetten.',
  },
  {
    key: 'klassen_leerlingen',
    label: 'Klassen en leerlingen',
    kort: 'Klassen en leerlingen',
    uitleg: 'Klassen maken, wijzigen, samenvoegen en verwijderen. Leerlingen in een klas zetten of eruit halen.',
  },
  {
    key: 'toegankelijkheid',
    label: 'Voorlezen en extra tijd',
    kort: 'Voorlezen en extra tijd',
    uitleg: 'Per leerling voorlezen, extra tijd en spelling niet beoordelen aanzetten. Zonder dit recht zie je deze instellingen ook niet.',
  },
  {
    key: 'coaching_inzien',
    label: 'Coachinggesprekken inzien',
    kort: 'Coachinggesprekken',
    uitleg: 'Coaching · beheer openen. Je ziet alle gesprekken van de school, met de antwoorden van de leerling en het verslag. Elk geopend gesprek komt in het logboek.',
  },
  {
    key: 'gegevens_wissen',
    label: 'Gegevens wissen en bewaartermijnen',
    kort: 'Gegevens wissen',
    uitleg: 'Gegevens van een leerling of een toets wissen, en de bewaartermijnen van de school korter zetten. Wissen kan niet ongedaan worden.',
  },
  {
    key: 'koppelingen',
    label: 'Koppelingen',
    kort: 'Koppelingen',
    uitleg: 'Zermelo en Edu-V koppelen, ontkoppelen en synchroniseren.',
  },
  {
    key: 'instellingen',
    label: 'Schoolinstellingen en functies',
    kort: 'Functies',
    uitleg: 'Per docent functies aan- of uitzetten, zoals toetsen of coaching.',
  },
  {
    key: 'beheerders',
    label: 'Beheerders en hun rechten',
    kort: 'Beheerders en rechten',
    uitleg: 'Bepalen wat elke beheerder mag. De hoofdbeheerder heeft dit recht altijd.',
  },
];

export const BEHEERRECHT_KEYS = BEHEERRECHTEN.map((r) => r.key);

export const beheerrechtLabel = (key, kort = false) => {
  const r = BEHEERRECHTEN.find((x) => x.key === key);
  return r ? (kort ? r.kort : r.label) : key;
};

/** De rechten die dit profiel echt heeft, in vaste volgorde. */
export function beheerrechtenVan(profiel) {
  if (!profiel) return [];
  if (profiel.rol === 'admin') return [...BEHEERRECHT_KEYS];
  if (profiel.rol !== 'schoolbeheerder') return [];
  if (profiel.beheerrechten === undefined) return [...BEHEERRECHT_KEYS]; // vóór migratie 117
  const eigen = Array.isArray(profiel.beheerrechten) ? profiel.beheerrechten : [];
  return BEHEERRECHT_KEYS.filter((k) => eigen.includes(k) || (k === 'beheerders' && profiel.hoofdbeheerder === true));
}

export function heeftBeheerrecht(profiel, recht) {
  return beheerrechtenVan(profiel).includes(recht);
}

// Welke tab in Schoolbeheer welk recht vraagt (één van de lijst is genoeg). Overzicht,
// Docenten, Beheerders en School ziet elke beheerder.
export const TAB_RECHTEN = {
  klassen: ['klassen_leerlingen'],
  leerlingen: ['klassen_leerlingen', 'toegankelijkheid'],
  koppelingen: ['koppelingen'],
  // Toezicht op medewerkers (122): hoofdbeheerder (heeft 'beheerders' altijd) of dat recht.
  toezicht: ['beheerders'],
};

export function magTab(rechten, tab) {
  const nodig = TAB_RECHTEN[tab];
  if (!nodig) return true;
  return nodig.some((r) => (rechten || []).includes(r));
}
